import { communityFeedHref } from './community-feed-location'
import { SEO_ORIGIN } from './company'
import { withLocalePath } from './i18n-utils'
import { jsonLd } from './seo-head'
import { discussionStructuredData } from './discussion-structured-data'
import type { PublicDiscussion } from '@/server/ssr-community'

/** Accept only public, published discussion data from ssrCommunity. */
export function discussionHead(data: PublicDiscussion | undefined, threadId: string, locale: string, focused=false) {
 const links=[{rel:'alternate',type:'application/rss+xml',title:locale==='bs-BA'?'Ažuriranja diskusije':'Discussion updates',href:communityFeedHref(threadId)}]
 const original=data?.items.find(item=>item.id===threadId&&item.parentId===null)
 if((!original&&!focused)||!data?.discussion||data.discussion.id!==threadId)return {meta:[{name:'robots',content:'noindex,follow'}]}
 if(original?.withdrawnAt)return {
  meta:[{title:locale==='bs-BA'?'Povučen doprinos — Horizon Tech zajednica':'Withdrawn contribution — Horizon Tech community'},{name:'robots',content:'noindex,follow'}],
  links, scripts:[],
 }
 const title=`${original?.title??data.discussion.title} — Horizon Tech community`
 const description=original?.body.replace(/\s+/g,' ').trim().slice(0,180)||data.discussion.title
 const url=SEO_ORIGIN+withLocalePath(`/community/${threadId}`,locale)
 const structured=discussionStructuredData(data.items,threadId,locale)
 return {
  links, meta:[{title},{name:'description',content:description},{name:'robots',content:focused?'noindex,follow':'index,follow'},
   {property:'og:title',content:title},{property:'og:description',content:description},
   {property:'og:type',content:'article'},{property:'og:url',content:url},
   {name:'twitter:title',content:title},{name:'twitter:description',content:description}],
  scripts:structured?[jsonLd(structured)]:[],
 }
}
